const universities = [
  // HUNAN UNIVERSITY OF CHINESE MEDICINE
  {
    name: 'HUNAN UNIVERSITY OF CHINESE MEDICINE',
    country: 'CHINA',
    province: 'HUNAN',
    city: 'CHANGSHA',
    district: 'YUELE',
    programmes: ["Bachelor's Degree"],
    levels: ['degree'],
    courses: {
      degree: [
        {
          course: 'medicine and surgery (MBBS)',
          fee: '',
          duration: '6 years',
          languageTaught: 'english'
        },
        {
          course: 'Chinese Medicine',
          fee: '',
          duration: '6 years',
          languageTaught: 'chinese'
        },
      ],
      // masters: [
      //   {
      //     course: 'medicine and surgery (MBBS)',
      //     fee: '',
      //     duration: '6 years',  
      //     languageTaught: 'english'
      //   },
      // ],
    },
    fees: 'See more and structure fees',
    // pdfDocument: '/docs/unis/hunan.pdf',
  },

  // PARUL UNIVERSITY
  {
    name: "PARUL UNIVERSITY",
    country: "INDIA",
    province: "GUJARAT",
    city: "VADODARA",
    district: "LIMDA",
    levels: ["diploma", "degree", "master's", "PhD"],
    programmes: ["PhD", "Bachelor's Degree", "Master's Degree", "Diploma and Certificate"],
    courses: {
      // "diploma": [
      //   {
      //     "course": "Diploma in Engineering (DE)",
      //     "fee": "$1600 per semester",
      //     "duration": "3 years",
      //     "languageTaught": "english"
      //   },
      //   {
      //     "course": "Diploma in Pharmacy (D.Pharm)",
      //     "fee": "$1600 per semester",
      //     "duration": "2 years",
      //     "languageTaught": "english"
      //   },
      //   {
      //     "course": "Diploma in Aviation Management (DVM)",
      //     "fee": "$1900 per semester",
      //     "duration": "1 year",
      //     "languageTaught": "english"
      //   }
      // ],
      degree: [
        {
          course: "LAW",
          fee: "$1,900",
          duration: "3 years",
          languageTaught: "english"
        },
          {
          course: "Aeronautical Engineering",
          fee: "$2100",
          duration: "4 years",
          languageTaught: "english"
        },
        
        {
          course: "Agricultural Engineering",
          fee: "$2100",
          duration: "4 years",
          languageTaught: "english"
        },
        {
          course: "Automobile Engineering",
          fee: "$2100",
          duration: "4 years",
          languageTaught: "english"
        },
        
        {
          course: "Automotive Technology",
          fee: "$2100",
          duration: "4 years",
          languageTaught: "english"
        },
        
        {
          "course": "Bio-Medical Engineering",
          "fee": "$2100",
          "duration": "4 years",
          "languageTaught": "english"
        },
        
        {
          "course": "Biotechnology",
          "fee": "$2100",
          "duration": "4 years",
          "languageTaught": "english"
        },
        
        {
          "course": "Chemical Engineering",
          "fee": "$2100",
          "duration": "4 years",
          "languageTaught": "english"
        },
        
        {
          "course": "Civil Engineering",
          "fee": "$2100",
          "duration": "4 years",
          "languageTaught": "english"
        },
        
        {
          "course": "Computer Engineering",
          "fee": "$2100",
          "duration": "4 years",
          "languageTaught": "english"
        },
        
        {
          "course": "Electrical Engineering",
          "fee": "$2100",
          "duration": "4 years",
          "languageTaught": "english"
        },
        
        {
          "course": "Electronics & Communication Engineering",
          "fee": "$2100",
          "duration": "4 years",
          "languageTaught": "english"
        },
        
        {
          "course": "Food Technology",
          "fee": "$2100",
          "duration": "4 years",
          "languageTaught": "english"
        },
        
        {
          "course": "Mechatronics Engineering",
          "fee": "$2100",
          "duration": "4 years",
          "languageTaught": "english"
        },
        
        {
          "course": "Medicine and  Surgery (MBBS)",
          "fee": "$30,000",
          "duration": "5.5 years",
          "languageTaught": "english"
        },
        {
          "course": "Nursing",
          "fee": "$2500",
          "duration": "4 years",
          "languageTaught": "english"
        },
        {
          "course": "Business Administration (BBA)",
          "fee": "$1900",
          "duration": "3 years",
          "languageTaught": "english"
        },
        {
          "course": "ARTS",
          "fee": "$1,900",
          "duration": "3 years",
          "languageTaught": "english"
        },
        {
          "course": "others courses (admission officers will contact you)",
          "fee": "",
          "duration": "",
          "languageTaught": ""
        },
      ],

      masters: [
        {
          "course": "Business Administration (MBA)",
          "fee": "$1,900",
          "duration": "2 years",
          "languageTaught": "english"
        },
        {
          "course": "Technology (M.Tech)",
          "fee": "$2,100",
          "duration": "2 years",
          "languageTaught": "english"
        },
        {
          "course": "Surgery (MS)",
          "fee": "$22,000–$50,000",
          "duration": "3 years",
          "languageTaught": "english"
        },
        {
          "course": "Docotor of medicine",
          "fee": "$1,500-$58,000",
          "duration": "2 years",
          "languageTaught": "english"
        },
        {
          "course": "others courses (admission officers will contact you)",
          "fee": "",
          "duration": "",
          "languageTaught": ""
        },
        
      ],
      // "phd": [
      //   {
      //     "course": "Doctor of Philosophy (Ph.D.)",
      //       "fee": "$2000",
      //     "duration": "3 years",
      //     "languageTaught": "english"
      //   }
      // ]
    },
    fees: "",
    // "pdfDocument": "/docs/unis/perul.pdf"
  },

  // NANCHANG HANGKONG UNIVERSITY
  {
    name: 'NANCHANG HANGKONG UNIVERSITY',
    country: 'CHINA',
    province: 'JIANGXI',
    city: 'NANCHANG',
    district: 'XINJIAN',
    programmes: ["Master's Degree", "Bachelor's Degree"],
    levels: ['degree', 'masters'],
    courses: {
      degree: [
        {
          course: 'Aeronautical Engineering / Flight Vehicle Design & Engineering',
          fee: 'RMB 16,000/year',
          duration: '4 years',
          languageTaught: 'english'
        },
        {
          course: 'Computer Science and Technology',
          fee: 'RMB 16,000/year',
          duration: '4 years',
          languageTaught: 'english'
        },
        {
          course: 'Civil Engineering',
          fee: 'RMB 16,000/year',
          duration: '4 years',
          languageTaught: 'english'
        },
        {
          course: 'Business Administration',
          fee: 'RMB 14,000/year',
          duration: '4 years',
          languageTaught: 'english'
        },
        {
          course: 'International Economy & Trade / International Trade and Business',
          fee: 'RMB 14,000/year',
          duration: '4 years',
          languageTaught: 'english'
        },
      ],
      masters: [
        {
          course: 'Aeronautical Engineering',
          fee: 'RMB 20,000/year',
          duration: '3 years',
          languageTaught: 'english'
        },
        {
          course: 'Civil Engineering',
          fee: 'RMB 20,000/year',
          duration: '3 years',
          languageTaught: 'english'
        },
        {
          course: 'Computer Science & Technology',
          fee: 'RMB 20,000/year',
          duration: '3 years',
          languageTaught: 'english'
        },
        {
          course: 'Materials Science & Engineering',
          fee: 'RMB 20,000/year',
          duration: '3 years',
          languageTaught: 'english'
        },
        {
          course: 'Control Theory and Engineering',
          fee: 'RMB 20,000/year',
          duration: '3 years',
          languageTaught: 'english'
        },
        {
          course: 'Environmental Science & Engineering',
          fee: 'RMB 20,000/year',
          duration: '3 years',
          languageTaught: 'english'
        },
        {
          course: 'Management of Science and Engineering',
          fee: 'RMB 20,000/year',
          duration: '3 years',
          languageTaught: 'english'
        },
      ],
    },
    fees: 'See more and structure fees',
    pdfDocument: '#',
  },

  // YANGTZE UNIVERSITY
  {
    name: 'YANGTZE UNIVERSITY',
    country: 'CHINA',
    province: 'HUBEI',
    city: 'JINGZHOU',
    district: 'JINGZHOU',
    programmes: ["Master's Degree", "Bachelor's Degree"],
    levels: ['degree', 'masters'],
    courses: {
      degree: [
        {
          course: 'Clinical Medicine',
          fee: '',
          duration: '6 years',
          languageTaught: 'chinese'
        },
        {
          course: 'International Economy and Trade',
          fee: '',
          duration: '4 years',
          languageTaught: 'english/chinese'
        },
        {
          course: 'Computer Science and Technology',
          fee: '',
          duration: '4 years',
          languageTaught: 'english/chinese'
        },
        {
          course: 'Electrical Engineering',
          fee: '',
          duration: '4 years',
          languageTaught: 'english/chinese'
        },
        {
          course: 'Petroleum Engineering',
          fee: '',
          duration: '4 years',
          languageTaught: 'english/chinese'
        },
        {
          course: 'Mechanical Engineering',
          fee: '',
          duration: '4 years',
          languageTaught: 'english/chinese'
        },
      ],
      masters: [
        {
          course: 'Applied Economics',
          fee: '',
          duration: '3 years',
          languageTaught: 'english/chinese'
        },
        {
          course: 'Agriculture & Forest Economics and Management',
          fee: '',
          duration: '3 years',
          languageTaught: 'english/chinese'
        },
        {
          course: 'Accounting, Financial Management',
          fee: '',
          duration: '2 years',
          languageTaught: 'english/chinese'
        },
        {
          course: 'Mathematics, Physics, Environmental Science',
          fee: '',
          duration: '3 years',
          languageTaught: 'english/chinese'
        },
        {
          course: 'Chemical Engineering & Applied Chemistry',
          fee: '',
          duration: '3 years',
          languageTaught: 'english/chinese'
        },
        {
          course: 'Geology-related fields (e.g. Geological Engineering, Geochemical Engineering)',
          fee: '',
          duration: '3 years',
          languageTaught: 'english/chinese'
        },
        {
          course: 'Mechanical, Electrical, Petroleum & Civil Engineering areas',
          fee: '',
          duration: '3 years',
          languageTaught: 'english/chinese'
        },
      ],
    },
    fees: 'See more and structure fees',
    pdfDocument: '/docs/unis/yangtze.pdf',
  },

  // SHIHEZI UNIVERSITY
  {
    name: 'SHIHEZI UNIVERSITY',
    country: 'CHINA',
    province: 'XINJIANG UYGUR AUTONOMOUS REGION',
    city: 'SHIHEZI',
    district: 'SHIHEZI',
    programmes: ["Master's Degree", "Bachelor's Degree"],
    levels: ['degree'],
    courses: {
      degree: [
        {
          course: 'medicine and surgery (MBBS)',
          fee: '',
          duration: '6 years',
          languageTaught: 'english'
        },
        {
          course: 'pharmacy',
          fee: '',
          duration: '',
          languageTaught: 'english'
        },
      ],
    },
    fees: 'See more and structure fees',
    pdfDocument: '/docs/unis/shihez.pdf',
  },

  // other universities
  {
    name: 'OTHER UNIVERSITIES, (let us suitablly decide for you)',
    country: 'any',
    province: 'any',
    city: 'any',
    district: 'any',
    levels: ['degree', 'masters'],
    courses: {
      degree: [
        {
          course: 'others courses',
          fee: '(admission officers will contact you)',
          duration: '',
          languageTaught: ''
        },
        {
          course: 'medicine and surgery (MBBS)',
          fee: '',
          duration: '6 years',
          languageTaught: 'english'
        },
        {
          course: 'Chinese Medicine',
          fee: '',
          duration: '6 years',
          languageTaught: 'chinese'
        },
        {
          course: 'Aeronautical Engineering / Flight Vehicle Design & Engineering',
          fee: 'RMB 16,000/year',
          duration: '4 years',
          languageTaught: 'english'
        },
        {
          course: 'Computer Science and Technology',
          fee: 'RMB 16,000/year',
          duration: '4 years',
          languageTaught: 'english'
        },
        {
          course: 'Civil Engineering',
          fee: 'RMB 16,000/year',
          duration: '4 years',
          languageTaught: 'english'
        },
        {
          course: 'Business Administration',
          fee: 'RMB 14,000/year',
          duration: '4 years',
          languageTaught: 'english'
        },
        {
          course: 'International Economy & Trade / International Trade and Business',
          fee: 'RMB 14,000/year',
          duration: '4 years',
          languageTaught: 'english'
        },
        
      ],
      masters: [
        {
          course: 'others courses',
          fee: '(admission officers will contact you)',
          duration: '',
          languageTaught: ''
        },
        {
          course: 'Applied Economics',
          fee: '',
          duration: '3 years',
          languageTaught: 'english/chinese'
        },
        {
          course: 'Agriculture & Forest Economics and Management',
          fee: '',
          duration: '3 years',
          languageTaught: 'english/chinese'
        },
        {
          course: 'Accounting, Financial Management',
          fee: '',
          duration: '2 years',
          languageTaught: 'english/chinese'
        },
        {
          course: 'Mathematics, Physics, Environmental Science',
          fee: '',
          duration: '3 years',
          languageTaught: 'english/chinese'
        },
        {
          course: 'Chemical Engineering & Applied Chemistry',
          fee: '',
          duration: '3 years',
          languageTaught: 'english/chinese'
        },
        {
          course: 'Geology-related fields (e.g. Geological Engineering, Geochemical Engineering)',
          fee: '',
          duration: '3 years',
          languageTaught: 'english/chinese'
        },
        {
          course: 'Mechanical, Electrical, Petroleum & Civil Engineering areas',
          fee: '',
          duration: '3 years',
          languageTaught: 'english/chinese'
        },
        
      ],
    },
    pdfDocument: '#',
  },

];

export { universities };




